export const upsellingHc = {
  servicios: {
    accommodation: "Obiekt",
    all: "Wszystkie",
    state: "Status",
    search: "Szukaj",
    searchPlaceholder: "Gość lub kod rezerwacji…",
    from: "Od",
    to: "Do",
    today: "Dziś",
    noDate: "Bez daty",
    clear: "Wyczyść",
    thService: "Usługa",
    thGuest: "Gość",
    thBooking: "Rezerwacja",
    thRequested: "Zgłoszono",
    statusConsult: "Na zapytanie",
    statusRejected: "Odrzucone",
    statusPaid: "Opłacone",
    statusPartial: "Płatność częściowa",
    statusApproved: "Zatwierdzone",
    statusPending: "Oczekujące",
    serviceFallback: "Usługa",
    openBookingTitle: "Otwórz rezerwację",
    approve: "Zatwierdź",
    reject: "Odrzuć",
    viewBooking: "Zobacz rezerwację",
    noRecords: "Brak wpisów",
    noRecordsFiltered: "Nie znaleziono wpisów dla zastosowanych filtrów.",
    noRequestsYet: "Gdy tylko gość poprosi o usługę, pojawi się ona tutaj.",
    chipBreakfast: "Śniadanie",
    chipTour: "Wycieczka",
    chipTransport: "Transport",
    chipMore: "I cokolwiek jeszcze w ofercie",
    approveTitle: "Zatwierdź prośbę",
    amountLabel: "Kwota do pobrania",
    amountFree: "0 = bez opłaty",
    amountHint: "Przy podłączonej bramce płatniczej gość otrzymuje <strong>link do płatności</strong> (WhatsApp + e-mail). W przeciwnym razie dostaje informację, że <strong>zapłaci na miejscu</strong>.",
    cancel: "Anuluj",
    processing: "Przetwarzanie…",
    approveAndNotify: "Zatwierdź i powiadom",
    amountInvalid: "Proszę podać prawidłową kwotę (0 = bez opłaty).",
    approvedPaymentLink: "Zatwierdzono. Link do płatności został wysłany do gościa (WhatsApp + e-mail).",
    approvedOnArrival: "Zatwierdzono. Gość zapłaci na miejscu (brak podłączonej bramki).",
    approvedNotified: "Zatwierdzono. Gość został powiadomiony.",
    approveFailed: "Nie udało się zatwierdzić prośby.",
    rejectTitle: "Odrzuć prośbę",
    rejectMessage: "Po odrzuceniu gość NIE zostanie obciążony za tę usługę i otrzyma powiadomienie. Odrzucić prośbę?",
    rejected: "Prośba odrzucona. Gość został powiadomiony.",
    rejectFailed: "Nie udało się odrzucić prośby.",
  },
  form: {
    basicTitle: "Informacje podstawowe",
    basicDesc: "Nazwa i opis, które zobaczy gość.",
    autoTranslate: "Tekst należy napisać we <strong>własnym języku</strong>. Po zapisaniu jest tłumaczony <strong>automatycznie</strong> na wszystkie języki (hiszpański, angielski, portugalski, francuski, niemiecki, włoski, chiński i arabski), a gość zobaczy swój.",
    selectPlaceholder: "Proszę wybrać…",
    catNightlife: "Życie nocne",
    subtitleLabel: "Podtytuł",
    optional: "opcjonalnie",
    subtitlePlaceholder: "Krótki haczyk, np.: „Przeżyj tę przygodę”",
    price: "Cena",
    priceDesc: "Sposób naliczania tej usługi gościowi.",
    segWithPrice: "Z ceną",
    segWithPriceDesc: "Naliczana automatycznie",
    segOnRequest: "Na zapytanie",
    segOnRequestDesc: "Gość pyta, gospodarz wycenia",
    currencyLabel: "Waluta",
    currencyHint: "waluta oferty",
    chargeBy: "Nalicz wg",
    unitPlaceholder: "Proszę wybrać tryb…",
    unitPerUnit: "Za sztukę (cena stała)",
    unitPerPerson: "Za osobę (× goście)",
    unitPerNight: "Za noc (× noce)",
    unitPerGroup: "Za grupę / pobyt",
    unitPerHour: "Za godzinę",
    unitHintPerson: "Zostanie pomnożona przez liczbę gości w rezerwacji.",
    unitHintNight: "Zostanie pomnożona przez liczbę nocy w rezerwacji.",
    unitHintUnit: "Cena stała za każdą sztukę kupioną przez gościa.",
    unitHintGroup: "Jedna cena za rezerwację, niezależnie od liczby osób i nocy.",
    unitHintHour: "Cena za zarezerwowaną godzinę.",
    unitLabelPerson: "/ za osobę",
    unitLabelNight: "/ za noc",
    unitLabelGroup: "/ za pobyt",
    unitLabelHour: "/ za godzinę",
    stockControl: "Kontroluj stan",
    inventory: "magazyn",
    stockDesc: "Dla rzeczy, które się kończą (np. dostawka albo łóżeczko): ograniczenie liczby sztuk. Odejmują się same przy każdej rezerwacji i w czasie rzeczywistym.",
    unitsAvailable: "Dostępne sztuki",
    removeUnitAria: "Usuń jedną sztukę",
    addUnitAria: "Dodaj jedną sztukę",
    stockNoteSoldOut: "Przy <strong>0</strong> sztuk usługa wyświetla się jako <strong>Wyprzedane</strong> i nie można jej dodać.",
    stockNoteAuto: "Po osiągnięciu 0 automatycznie wyświetli się <strong>Wyprzedane</strong>.",
    stockConsumePerson: "Każda rezerwacja odejmuje 1 sztukę na gościa.",
    stockConsumeNight: "Każda rezerwacja odejmuje 1 sztukę na noc.",
    stockModeTitle: "Jak działa stan magazynowy",
    stockModeAvail: "Wg dostępności",
    stockModeAvailDesc: "Jest zajęta tylko podczas pobytu i zwalniana przy check-oucie (łóżeczko, dostawka).",
    stockModeProduct: "Wg produktu",
    stockModeProductDesc: "Odejmuje się przy każdej rezerwacji i nie wraca. Uzupełnienie odbywa się ręcznie.",
    stockUnlimited: "Stan nieograniczony: bez limitu sztuk.",
    photosTitle: "Zdjęcia",
    photoMain: "Główne",
    makeMainTitle: "Ustaw jako główne",
    removeTitle: "Usuń",
    addPhoto: "Dodaj zdjęcie",
    addPhotos: "Dodaj zdjęcia",
    reorderHint: "Przeciągnij, aby zmienić kolejność · pierwsze wyświetla się na karcie.",
    whereTitle: "Gdzie jest oferowana?",
    whereDesc: "Oferty, w których będzie dostępna. Brak wyboru = wszystkie.",
    selected: "Wybrano: {count}",
    all: "Wszystkie",
    none: "Żadna",
    searchListingPlaceholder: "Szukaj oferty…",
    noResults: "Brak wyników",
    diffCurrencyTitle: "Ta oferta używa waluty {currency}. Usługa ma jedną walutę.",
    unit: "sztuka",
    units: "sztuk",
    loadingListings: "Wczytywanie ofert…",
    previewLabel: "Podgląd · tak zobaczy to gość",
    previewPhoto: "Zdjęcie główne",
    previewTitleFallback: "Nazwa usługi",
    previewDescFallback: "Tutaj pojawi się wpisany opis, aby gość wiedział, co jest w cenie.",
    free: "Bezpłatnie",
    soldOut: "Wyprzedane",
    add: "Dodaj",
    remaining: "Pozostała {count} sztuka | Pozostały {count} sztuki | Pozostało {count} sztuk",
    scopeManaged: "Dostępna we <strong>wszystkich Twoich ofertach</strong>. Wybierz, w których, na liście Usługi i atrakcje.",
    scopeAll: "Dostępna we <strong>wszystkich obiektach</strong>",
    scopeSome: "Dostępna w <strong>{count}</strong> ofercie | Dostępna w <strong>{count}</strong> ofertach | Dostępna w <strong>{count}</strong> ofertach",
    errNameRequired: "Nazwa jest wymagana",
    errCategoryRequired: "Kategoria jest wymagana",
    errDescRequired: "Opis jest wymagany",
    errPriceRequired: "Proszę podać cenę (0, jeśli usługa jest bezpłatna).",
    errPriceNegative: "Cena nie może być ujemna.",
    errUnitRequired: "Proszę wybrać sposób naliczania (Nalicz wg)",
    errStockRequired: "Proszę podać liczbę sztuk w magazynie (0, jeśli wyprzedane).",
    errProcessing: "Błąd podczas przetwarzania żądania.",
  },
  createServicio: {
    subtitle: "Proszę uzupełnić informacje i obserwować podgląd na żywo.",
    photosDesc: "Można dodać dowolną liczbę · 1. jest główne · JPG, PNG lub WebP.",
    imageRequired: "Proszę wgrać co najmniej jedno zdjęcie.",
  },
  updateServicio: {
    title: "Edytuj atrakcję lub usługę",
    subtitle: "Proszę zaktualizować informacje i obserwować podgląd na żywo.",
    loadingAria: "Wczytywanie usługi",
    photosDesc: "Można dodawać i usuwać dowolną liczbę · 1. jest główne · JPG, PNG lub WebP.",
    save: "Zapisz zmiany",
    imageRequired: "Musi pozostać co najmniej jedno zdjęcie.",
    loadFailed: "Nie udało się wczytać usługi.",
  },
  configUpselling: {
    title: "Ustawienia sprzedaży krzyżowej",
    phoneIntro: "Proszę podać numer telefonu, na który mają przychodzić powiadomienia o prośbach o usługi przez WhatsApp",
    saveWhatsapp: "Zapisz WhatsApp",
    editWhatsapp: "Edytuj WhatsApp",
    mustEnterWhatsapp: "Należy podać numer WhatsApp",
    swalTitle: "WhatsApp sprzedaży krzyżowej",
    swalText: "Na ten numer będą przychodzić wszystkie powiadomienia o usługach zamawianych przez klientów",
    cancel: "Anuluj",
    addedSuccess: "Numer WhatsApp dodany pomyślnie",
  },
};
